<template>
    <option value="actual">actual value</option>
    <option value="mean">trending average</option>
    <option value="min">trending minimum</option>
    <option value="max">trending maximum</option>
</template>
